import { render, staticRenderFns } from "./AdManOrderDetail.vue?vue&type=template&id=4828e640&scoped=true"
import script from "./AdManOrderDetail.vue?vue&type=script&lang=js"
export * from "./AdManOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./AdManOrderDetail.vue?vue&type=style&index=0&id=4828e640&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4828e640",
  null
  
)

export default component.exports